export default "__VITE_ASSET__Dn_DdPwM__"